<div class="mb-3">
  <avs-text-input [label]="labelNew" [placeholder]="placeholderNew" type="password" [required]="required"
    [disabled]="disabled" [value]="password" (valueChange)="onPasswordChange($event)"></avs-text-input>
</div>
<div>
  <avs-text-input [label]="labelConfirm" [placeholder]="placeholderConfirm" type="password" [required]="required"
    [disabled]="disabled" [value]="confirmPassword" (valueChange)="onConfirmPasswordChange($event)"></avs-text-input>
  <span *ngIf="isMismatch" class="text-danger small">Die Passwörter stimmen nicht überein.</span>
</div>
